// frontend/src/hooks/use-subscription-status.ts
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { subscriptionBlockedModal } from "@/components/admin/SubscriptionBlockedModal";
import { useBranchOwner } from "@/hooks/use-branch-owner";
import { getSubscriptionStatus, resolveSubscriptionDoctorId } from "@/lib/permissions";
import { getCurrentSubscriptionQuery } from "@/modules/settings/queries";
import { useSession } from "@/providers/session-provider";

export function useSubscriptionStatus() {
	const session = useSession();
	const { ownerDoctorId, isGuest } = useBranchOwner();

	const doctorId = resolveSubscriptionDoctorId({
		ownerDoctorId,
		isGuest,
		sessionDoctorId: session?.id,
	});

	const subscriptionQuery = useQuery(getCurrentSubscriptionQuery({ doctorId }));

	const result = getSubscriptionStatus({
		status: subscriptionQuery.data?.status,
		trialEndsAt: subscriptionQuery.data?.trialEndsAt,
		endsAt: subscriptionQuery.data?.endsAt,
	});

	const showBlockedModal = useCallback(() => {
		if (!result.status) return;
		subscriptionBlockedModal.open({ status: result.status });
	}, [result.status]);

	return {
		...subscriptionQuery.data,
		...result,
		isLoading: subscriptionQuery.isLoading,
		error: subscriptionQuery.error,
		showBlockedModal,
	};
}
